import * as React from 'react';
import classnames from 'classnames';
import { Util, LazyImage } from '@grandvisionhq/common';
import { placeholderImage } from '@grandvisionhq/utils';

const params = {
    fit: 'fill',
    format: 'jpeg',
    width: 40,
    height: 23,
    aspectRatio: 16 / 9
};
const VariantSwitcherItem = ({ image , sku , isActive , onClick , disableTabIndex ,  })=>{
    const handleClick = React.useCallback((e)=>{
        onClick(sku);
        e.preventDefault();
        e.stopPropagation();
    }, [
        onClick,
        sku
    ]);
    const imageUrl = image ? Util.createImgUrl(image.url, params) : placeholderImage.url;
    const imageAlt = (image === null || image === void 0 ? void 0 : image.altTag) || '';
    return /*#__PURE__*/ React.createElement("button", {
        onClick: handleClick,
        "aria-label": imageAlt,
        className: classnames('variant-switcher-item', {
            'variant-switcher-item--active': isActive
        }),
        tabIndex: disableTabIndex ? -1 : undefined
    }, /*#__PURE__*/ React.createElement(LazyImage, {
        className: "variant-switcher-item__image",
        src: imageUrl,
        alt: imageAlt,
        height: params.height,
        width: params.width
    }));
};

export { VariantSwitcherItem };
//# sourceMappingURL=VariantSwitcherItem.js.map
